import React, { useContext, useEffect, useState } from 'react'
import { Icon, Modal } from 'semantic-ui-react';
import { AuthContext } from "../../Auth.js";
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';

const Agregar =()=>{
    const [db] = useState(firebase.firestore().collection('Vales'))
    const [modalCombustible, setModalC] = useState(false)
    const today = new Date();
    const fecha = today.getDate()+'/'+(today.getMonth()+1)+'/'+today.getFullYear()+' '+today.getHours()+':'+today.getMinutes();
    const { currentUser } = useContext(AuthContext)
    const [userName] = useState(currentUser.name)
    const [codigo] = useState(0)
    const [combustible, setCombistible] = useState("Gasolina")
    const [vehiculo, setVehiculo] = useState("")
    const [placas, setPlacas] = useState("")
    const [ticket, setTicket] = useState(0)
    const [kilometraje, setKilometraje] = useState(0)
    const [litros, setLitros] = useState(0)
    const [precio, setPrecio] = useState(0)
    const [destino, setDestino] = useState("")
    const [descripcion, setDescripcion] = useState("")

    useEffect(()=>{
        console.log(codigo)
    })

    const addVale = () => { 
		db.add({
			id: "1",
			codigo: codigo,
			tipo: combustible,
			vehiculo: vehiculo,
			placas: placas,
			fecha: today,
			ticket: ticket,
            kilometraje: kilometraje,
            litros: litros,
            precio: precio,
            destino: destino,
            descripcion: descripcion
		})
	}

    const AddValeGeneral = () => (
        <Modal 
			onClose={() => setModalC(false)}
			onOpen={() => setModalC(true)}
			open={modalCombustible}
			trigger={<button><Icon name='plus' />Completar</button>}>
			<Modal.Header>
                <div>
                    <div className='inline'>Vale de Gasolina/Diesel</div>
                    <button 
                        className='borrar right' style={{padding: "0"}}
                        onClick={() => setModalC(false)}>
                        <Icon name='close' />
                    </button>
                </div>
                <div className='description'>
                    <div className='inline'>Por: {userName}</div>
                    <div className='inline right'>{fecha}</div>
                </div>
            </Modal.Header>
			<Modal.Content>
                <form onSubmit={addVale}>
                    <div className="input">Vehiculo: <input type='text' placeholder="Marca" 
                        name='nombre' required={true} onChange={e => setVehiculo(e.target.value)}/>
                    </div>
                    <div className="input">Placas: <input type='text' placeholder="Placas" 
                        name='categoria' onChange={e => setPlacas(e.target.value)}/>
                    </div>
                    <div className="input">Combustible: <select required={true} 
                        onChange={e => setCombistible(e.target.value)}>
                            <option>Gasolina</option>
                            <option>Diesel</option>
                        </select>
                    </div>
                    <div className="input">Precio Minimo: <input type='float' placeholder='Pesos' 
                        name='precioMin' onChange={e => setPrecio(e.target.value)} />
                    </div>
                    <p><button>Agregar</button></p>
                </form>
			</Modal.Content>
		</Modal>
    )
    
    return(
        <div>
            <button onClick={() => setModalC(true)}>Vale Gasolina/Diesel</button>
            <AddValeGeneral />
        </div>
    )

}

export default Agregar